import { useEffect, useState } from "react";
import { useUpdateAssignmentMarkMutation } from "../../../features/AssignmentMark/assignmentMarkApi";

export default function AssignmentMarkItem({ assignmentMark }) {
  const { title, createdAt, student_name, repo_link, mark, status, totalMark } =
    assignmentMark || {};
  const [newMark, setNewMark] = useState(0);
  const [updateAssignmentMark, { isError, error }] =
    useUpdateAssignmentMarkMutation();

  const date = new Date(createdAt);
  const options = {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
    hour12: true,
  };
  const formattedDate = date.toLocaleString("en-US", options);

  const handleMarkUpdate = () => {
    if (newMark > totalMark) {
      alert(`Highest mark for this assignment is ${totalMark}!`);
      return;
    }

    updateAssignmentMark({
      ...assignmentMark,
      mark: newMark,
      status: "published",
    });
  };

  useEffect(() => {
    if (isError) {
      alert(error?.data);
    }
  }, [isError]);

  return (
    <tr>
      <td className="table-td">{title}</td>
      <td className="table-td">{formattedDate}</td>
      <td className="table-td">{student_name}</td>
      <td className="table-td">{repo_link}</td>
      {status === "pending" ? (
        <td className="table-td input-mark">
          <input
            max={100}
            min={0}
            type="number"
            defaultValue={assignmentMark}
            value={newMark}
            onChange={(e) => setNewMark(e.target.valueAsNumber)}
          />
          <svg
            onClick={handleMarkUpdate}
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            stroke="currentColor"
            className="w-6 h-6 text-green-500 cursor-pointer hover:text-green-400"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M4.5 12.75l6 6 9-13.5"
            />
          </svg>
        </td>
      ) : (
        <td className="table-td">{mark}</td>
      )}
    </tr>
  );
}
